
import { Component, Vue, Mixins, Prop } from "vue-property-decorator";
import { namespace, Getter } from "vuex-class";
import { axiosInstance } from "@/axios.instance";
import RegionalHandlerMixin from "../mixins/RegionalHandlerMixin";
import { FilteredEvent } from "@/store/eventqueue/types";
import EventQueueAreaNotesIcon from "@/components/event-queue/EventQueueAreaNotesIcon.vue";
import LinkedTaskIcon from "@/components/alarm-queue/LinkedTaskIcon.vue";
import RestoreIcon from "@/components/event-queue/RestoreIcon.vue";
import { get } from "lodash";

const Eventqueue = namespace("eventqueue");

@Component({
	components: {
		"event-queue-area-notes-icon": EventQueueAreaNotesIcon,
		"linked-task-icon": LinkedTaskIcon,
		"restore-icon": RestoreIcon
	},
})
export default class ProcessingQueue extends Mixins(RegionalHandlerMixin) {
	$refs!: {
		confirmModal: any;
	};

	@Eventqueue.Getter("getActiveEvents") private activeEvents!: FilteredEvent[];
	@Eventqueue.Action private clearEventQueue: (eventId: number) => void;
	@Eventqueue.Mutation private setCountByType: ({ countType: string, count: number }) => void;
	@Eventqueue.Mutation private setHoverEvent: (evemt: FilteredEvent | {}) => void;

	private clearEventID: number = 0;

	private get events() {
		if (this.activeEvents == null) {
			return null;
		}

		let filteredEvents = this.activeEvents.filter((q: any) => q.eventTypeID == 1 && q.inProcessing == 1 && q.readyForPostProcessing == null);

		this.setCountByType({ countType: "inProcess", count: filteredEvents.length });

		return filteredEvents;
	}

	private get noEvents() {
		return typeof this.events == "undefined" || this.events == null || this.events.length == 0;
	}

	private get showDispatchedGuards(): boolean {
		return get(this.featuresList, ["Alarms", "EventQueue", "InProcessing", "DispatchedGuards"]);
	}

	private get showAlarmCount(): boolean{
		return get(this.featuresList, ["Alarms", "EventQueue", "InProcessing", "AlarmCountColumn"]);
	}

	private get isRestoredIconEnabled(): boolean {
		return get(this.featuresList, ["Alarms", "EventQueue", "RestoreIcon"], false);
	}

	private get isTypeColumnEnabled(): boolean {
		return get(this.featuresList, ["Alarms", "EventQueue", "ServerEventTitleInQueue"]);
	}

	private async clearEvent() {
		await this.clearEventQueue(this.clearEventID);
		this.$refs.confirmModal.hide();
	}

	public hoverEvent(event: FilteredEvent) {
		this.setHoverEvent(event);
	}

	public unhoverEvent(event: FilteredEvent) {
		this.setHoverEvent({});
	}

	public eventType(event: FilteredEvent): string {
		const title = event.serverEventTitle;
		return title == null ? "Unknown" : title.substring(0, Math.min(title.length, 50));
	}
}
